/**
 * Через сколько после последней попытки можно попросить оценку снова.
 *
 * Свой таймер обязателен, потому что ответ Play бесполезен как обратная связь: карточку он
 * душит собственной квотой (порядка раза в месяц на пользователя, значение намеренно не
 * документировано) и при исчерпанной квоте «успешно» не показывает ничего. Без этой отметки
 * приложение дёргало бы API вслепую.
 *
 * Девяносто дней, а не месяц Play: единственный человек, который увидит вторую карточку, —
 * тот, кто первую закрыл, не поставив оценку. Спрашивать такого чаще раза в квартал незачем.
 */
export const REVIEW_MIN_INTERVAL_MS = 90 * 24 * 60 * 60 * 1_000;

/**
 * Пауза между возвращением человека в приложение и просьбой оценить.
 *
 * Показываем не в момент результата, а в следующий заход (см. `reviewGate`), поэтому пауза
 * отсчитывается от запуска: пять секунд уходит на то, чтобы экран догрузился и стало видно,
 * не занят ли он чем-то ещё — обновлением, опросом, шторкой разрешений.
 */
export const REVIEW_VISIT_DELAY_MS = 5_000;

/**
 * Когда пробовать снова, если в первую попытку экран был занят. Отсчёт от той же точки, что и
 * `REVIEW_VISIT_DELAY_MS`. Две повторные попытки за заход — дальше ждём следующего: право
 * заработано и никуда не денется, а долбиться в занятый экран смысла нет.
 */
export const REVIEW_RETRY_DELAYS_MS = [30_000, 90_000];

/**
 * Отсутствие в приложении дольше получаса считается новым заходом.
 *
 * В приложении «запуск» — понятие условное: WebView живёт сутками, и холодный старт может не
 * случиться ни разу за неделю. Полчаса — граница, после которой возвращение ощущается как
 * приход заново, а не как переключение между двумя окнами.
 */
export const NEW_VISIT_AFTER_MS = 30 * 60 * 1_000;

/**
 * Когда в последний раз просили. Ключ общий для устройства, а не для аккаунта: оценка ставится
 * от имени аккаунта Play, а он на телефоне один независимо от того, кто вошёл в приложение.
 */
export const REVIEW_LAST_ASKED_KEY = 'store-review:last-asked';

/**
 * Заработанное право спросить: `{ at, reason }`.
 *
 * Хранится, а не живёт в памяти вкладки, именно потому, что показываем в следующий заход —
 * между поводом и карточкой приложение успевает закрыться.
 */
export const REVIEW_EARNED_KEY = 'store-review:earned';
